export default __webpack_public_path__ + "static/media/camera.a225845e.svg";